import { LOCALES } from "./locales";
export var i18nToLocale = {
    en: LOCALES.ENGLISH,
    ru: LOCALES.RUSSIAN,
    es: LOCALES.SPANISH,
    cs: LOCALES.CZECH,
    ar: LOCALES.ARABIC,
    he: LOCALES.HEBREW,
    it: LOCALES.ITALIAN,
    pl: LOCALES.POLISH,
    uk: LOCALES.UKRAINIAN,
    fr: LOCALES.FRENCH,
    de: LOCALES.GERMAN,
};
